export const HS_ROOM_RESERVATION = 'hotel_services_room_reservation';
export const HS_DIGITAL_CHECKIN = 'hotel_services_digital_checkin';
export const HS_DIGITAL_CHECKOUT = 'hotel_services_digital_checkout';
export const HS_SPA_RESERVATION = 'hotel_services_spa_reservation';
export const HS_SPA_INROOM_DINING = 'hotel_services_inroom_dining';
export const HS_RESTAURANT_RESERVATION = 'hotel_services_restaurant_reservation';
export const HS_HOUSEKEEPING = 'hotel_services_housekeeping';
export const HS_TELEPHONY = 'hotel_services_telephony';
export const HS_TELEPHONY_TLS_PORT = 'TLS (Port: 5061)';
export const HS_TELEPHONY_TCP_PORT = 'TCP/UDP (Port: 5060)';
export const HS_TELEPHONY_PORT_NONE = 'NONE';
export const HS_LOYALTY = 'loyalty';
export const HS_PAYMENT = 'payment';
export const HS_WEATHER = 'weather';
export const HS_KYC_DOC = 'documentScan';
export const HS_TS = 'ts';
export const HS_CHAT = 'chat';
export const HS_EVENTHUB = 'eventHub';
export const HS_ANALYTICS = 'analytics';
export const HS_TPNS = 'tpns';
export const HS_CRS = 'crs';

export const integrationSources = [
  {
    id: 'PMS',
    name: 'PMS',
  },
  {
    id: 'CRS',
    name: 'CRS',
  },
];

export const activeInactiveRadioOptions = [
  {
    id: 'Active',
    name: 'Active',
  },
  {
    id: 'Inactive',
    name: 'Inactive',
  },
];

export const posOptions = [
  { id: 'OPERA', name: 'Opera' },
  { id: 'INFOR', name: 'Infor' },
];

export const bookingOptions = [
  { id: 'API_INTEGRATION', name: 'API Integration' },
  { id: 'REDIRECT_URL', name: 'Redirect URL' },
  { id: 'BACKEND_VIA_EMAIL', name: 'Backend via Email' },
];

export const telephonyPort = [
  {
    id: 'TCP/UDP (Port: 5060)',
    name: 'TCP/UDP (Port: 5060)',
  },
  {
    id: 'TLS (Port: 5061)',
    name: 'TLS (Port: 5061)',
  },
];

export const telephonySecondaryPort = [
  {
    id: 'NONE',
    name: 'None',
  },
  {
    id: 'TCP/UDP (Port: 5060)',
    name: 'TCP/UDP (Port: 5060)',
  },
  {
    id: 'TLS (Port: 5061)',
    name: 'TLS (Port: 5061)',
  },
];
